import Konva from 'konva'

export default {
  data () {
    return {
      stage: {},
      layer: {},
      tempLayer: null,
      baseRect: {},
      imageObj: null,
      scaleScore: 1,
      containerHeight: 0,
      editorDataLoaded: false
    }
  },
  watch: {
    editorDataLoaded: {
      handler: function () {
        this.$nextTick(() => {
          if (this.editorDataLoaded && this.$refs.drawIcon) {
            this.$refs.drawIcon.focus()
          }
        })
      }
    }
  },
  methods: {
    init () {
      let vm = this
      let imageObj = new window.Image()
      const imageUrl = this.trainTemplate.webp_image_url || this.trainTemplate.image_url
      imageObj.src = process.env.API_URL.replace('/api', '') + imageUrl
      imageObj.onload = function () {
        let stageWidth = imageObj.width
        let stageHeight = imageObj.height

        vm.imageObj = imageObj
        vm.stage = new Konva.Stage({
          container: 'container',
          width: stageWidth,
          height: stageHeight
        })
        vm.layer = new Konva.Layer({ })

        let baseImage = new Konva.Image({
          image: imageObj,
          width: stageWidth,
          height: stageHeight
        })

        vm.baseRect = new Konva.Rect({
          name: 'baseRect',
          width: stageWidth,
          height: stageHeight,
          stroke: 'black',
          strokeWidth: 1
        })

        vm.layer.add(baseImage)
        vm.layer.add(vm.baseRect)
        vm.stage.add(vm.layer)

        vm.populateMappings(vm.trainTemplate.template_mappings)
        vm.initDrawTool()
        let editorClass = vm.$refs.canvasEditor.classList
        if (editorClass.contains('hidden-cn')) { editorClass.toggle('hidden-cn') }
        vm.scaleCanvas()
        vm.bindContextMenuOpen()
        vm.bindContextMenuClose()
        vm.stage.draw()

        vm.containerHeight = imageObj.height
        vm.editorDataLoaded = true
      }
    },

    scaleCanvas () {
      let container = document.getElementById('container')
      this.scaleScore = (container.offsetWidth) / this.stage.width()
      this.stage.width(this.stage.width() * this.scaleScore)
      this.stage.height(this.stage.height() * this.scaleScore)
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore })
      // listening on templateMapping.vue
      this.$root.$emit('setHeightMappings', this.stage.content.offsetHeight + 25)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/konvaCreator.js